import { UiSchema, WidgetProps } from '@rjsf/utils';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';
import { DynamicFormAutocomplete } from '../shared/dynamic-form-autocomplete';

const uiGrid: UIGridElement[] = [
  { fields: { name: 6, type: 6 } },
  { fields: { managedBy: 6, externalID: 6 } },
  { fields: { externalShortID: 6, displayAddress: 6 } },
  { fields: { openingHoursDisplay: 6 } },
  { title: 'Location', fields: { location: 12 } },
  { fields: { directions: 12 } },
  { fields: { additionalDirections: 12 } },
  { fields: { identificationNote: 12 } }
];

export const hubSettingsFormUISchema: UiSchema = {
  'ui:submitButtonOptions': {
    norender: true
  },
  'ui:field': 'custom',
  'ui:grid': uiGrid,
  'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
  managedBy: {
    'ui:widget': (props: WidgetProps) => {
      return <DynamicFormAutocomplete {...props} />;
    }
  },
  location: {
    'ui:field': 'locationPicker'
  }
};
